export enum Role {
  User = 1,
  Retail = 2,
  Wholesale = 4,
  Manufacturing = 8,
  Customer = 16,
  BankingIntegration = 32,
  Marketplace = 64,
  ECommerce = 128,
  Muhasebe = 256,
  Admin = 1024,
  SuperAdmin = 2048,
}

export const RoleList = [
  Role.User,
  Role.Retail,
  Role.Wholesale,
  Role.Manufacturing,
  Role.Customer,
  Role.BankingIntegration,
  Role.Muhasebe,
  Role.Admin,
]
